export const getModeValuesAvailable = (t, modeValues) => {
  const defaultModes = [
    { id: 1, label: t("stop"), value: 1, icon: "StopMode" },
    { id: 2, label: t("cool"), value: 2, icon: "Snowflake" },
    { id: 3, label: t("heat"), value: 3, icon: "Radiator" },
    { id: 4, label: t("fan"), value: 4, icon: "Fanmode" },
    { id: 5, label: t("dry"), value: 5, icon: "Drymode" },
    { id: 7, label: t("auto"), value: 7, icon: "Automode" },
  ];

  if (modeValues) {
    return defaultModes.filter((mode) => modeValues.includes(mode.value));
  }
  return defaultModes;
};

const getModeIcon = (mode) => {
  let icon = "";

  switch (mode) {
    case 1:
      icon = "StopMode";
      break;
    case 2:
      icon = "Snowflake";
      break;
    case 3:
      icon = "Radiator";
      break;
    case 4:
      icon = "Fanmode";
      break;
    case 5:
      icon = "Drymode";
      break;
    case 7:
      icon = "Automode";
      break;
    default:
      break;
  }

  return icon;
};

const getModeLabel = (modeActual, modeValues) => {
  const currentMode = modeValues.find((modeValue) => modeValue.value === modeActual);

  const modeLabel = currentMode?.label?.toUpperCase();

  return modeLabel || "";
};

export const getFanValuesAvailable = (t, type, speeds) => {
  let fanValuesAvailable = [];

  if (type === "Airzone") {
    switch (speeds) {
      case 3:
        fanValuesAvailable = [
          { id: 0, label: t("auto"), value: 0 },
          { id: 1, label: t("low"), value: 1 },
          { id: 2, label: t("medium"), value: 2 },
          { id: 3, label: t("high"), value: 3 },
        ];
        break;

      case 4:
        fanValuesAvailable = [
          { id: 0, label: t("auto"), value: 0 },
          { id: 1, label: t("low"), value: 1 },
          { id: 2, label: t("medium"), value: 2 },
          { id: 3, label: t("mediumHigh"), value: 3 },
          { id: 4, label: t("high"), value: 4 },
        ];
        break;

      case 5:
        fanValuesAvailable = [
          { id: 0, label: t("auto"), value: 0 },
          { id: 1, label: t("veryLow"), value: 1 },
          { id: 2, label: t("low"), value: 2 },
          { id: 3, label: t("medium"), value: 3 },
          { id: 4, label: t("mediumHigh"), value: 4 },
          { id: 5, label: t("high"), value: 5 },
        ];
        break;

      case 6:
        fanValuesAvailable = [
          { id: 0, label: t("auto"), value: 0 },
          { id: 1, label: t("veryLow"), value: 1 },
          { id: 2, label: t("low"), value: 2 },
          { id: 3, label: t("mediumLow"), value: 3 },
          { id: 4, label: t("medium"), value: 4 },
          { id: 5, label: t("mediumHigh"), value: 5 },
          { id: 6, label: t("high"), value: 6 },
        ];
        break;

      case 7:
      default:
        fanValuesAvailable = [
          { id: 0, label: t("auto"), value: 0 },
          { id: 1, label: t("veryLow"), value: 1 },
          { id: 2, label: t("low"), value: 2 },
          { id: 3, label: t("mediumLow"), value: 3 },
          { id: 4, label: t("medium"), value: 4 },
          { id: 5, label: t("mediumHigh"), value: 5 },
          { id: 6, label: t("high"), value: 6 },
          { id: 7, label: t("veryHigh"), value: 7 },
        ];
        break;
    }
  }

  return fanValuesAvailable;
};

const getFanLabel = (actualFanValue, fanValues) => {
  const currentFan = fanValues.find((fanValue) => fanValue.value === actualFanValue);

  const fanLabel = currentFan?.label?.toUpperCase();

  return fanLabel || "";
};

const getStageValuesAvailable = (t, actualStages) => {
  switch (actualStages) {
    case 0:
      return [{ id: 0, label: t("offLabel"), value: 0 }];
    case 1:
      return [{ id: 1, label: t("air"), value: 1 }];
    case 2:
      return [{ id: 2, label: t("radiant"), value: 2 }];
    case 3:
    default:
      return [
        { id: 1, label: t("air"), value: 1, icon: "Air" },
        { id: 2, label: t("radiant"), value: 2, icon: "Radiant" },
        { id: 3, label: t("combinated"), value: 3, icon: "Combinated" },
      ];
  }
};

const getStageLabel = (actualStage, stagesValuesAvailable) => {
  if (stagesValuesAvailable.length === 1) return stagesValuesAvailable[0]?.label?.toUpperCase();

  const currentStage = stagesValuesAvailable.find((stage) => stage.value === actualStage);

  const currentStageLabel = currentStage?.label?.toUpperCase();

  return currentStageLabel || "";
};

// eslint-disable-next-line consistent-return
const getIconStage = (airDemand, floorDemand) => {
  if (airDemand === null || floorDemand === null) return null;

  const combinated = airDemand && floorDemand;

  if (combinated) return "Combinated";
  if (airDemand) return "Air";
  if (floorDemand) return "Radiant";
};

const getAngleValuesValuesAvailable = (actualAngleValues) => {
  const defaultAngleValuesAvailable = [
    { id: 1, label: "90º", value: 90 },
    { id: 2, label: "50º", value: 50 },
    { id: 3, label: "45º", value: 45 },
    { id: 4, label: "40º", value: 40 },
  ];

  if (actualAngleValues) {
    return defaultAngleValuesAvailable.filter((angleValue) =>
      actualAngleValues.includes(angleValue.value)
    );
  }
  return defaultAngleValuesAvailable;
};

const getAngleConfLabel = (actualAngleConf, actualAngleValuesAvailable) => {
  const currentAngleConf = actualAngleValuesAvailable.find(
    (angleConf) => angleConf.value === actualAngleConf
  );

  const currentAngleConfLabel = currentAngleConf?.label?.toUpperCase();

  return currentAngleConfLabel || "";
};

export const utilsDevice15 = {
  getModeValuesAvailable,
  getFanValuesAvailable,
  getModeLabel,
  getFanLabel,
  getModeIcon,
  getStageValuesAvailable,
  getStageLabel,
  getIconStage,
  getAngleValuesValuesAvailable,
  getAngleConfLabel,
};
